<template>
    <div id="wrapper">
        <NavBarUser />
        <div class="nameInset">
            <div class="insetCont">
                <input type="text" :placeholder="$route.query.val" v-model="value">
                <van-icon name="arrow" class="arrow-right"/>
            </div>
            <div class="completeCon">
                <van-button type="default" class="complete" @click="complete($route.query.name)">完成</van-button>
            </div>
        </div>
    </div>
</template>

<script>
import { userUpdate } from "@/api/userReq";
import NavBarUser from "@/components/NavBarUser.vue";
import { Button, Icon, Notify } from "vant";
export default {
  data() {
    return {
      value: '',
      userinfo: {
          name: this.$store.state.userInfo.name,
          sex: this.$store.state.userInfo.sex,
          email: this.$store.state.userInfo.email,
          avatar: this.$store.state.userInfo.avatar,
          birthday: this.$store.state.userInfo.birthday,
          introduction: this.$store.state.userInfo.introduction
      }
    }
  },

  components: {
      NavBarUser,
      [Button.name]: Button,
      [Icon.name]: Icon,
      [Notify.name]: Notify
  },
  methods: {
    complete(name) {
      this.userinfo[name] = this.value;
      let category = name === 'introduction' ? 'introduction' : name;
      userUpdate(this.userinfo).then(res => {
        this.$store.dispatch('ChangeVmUserInfo',{category, msg: this.$data.value});
          // 提示
          Notify({
              message: '修改成功',
              duration: 1000,
              background: '#1989fa'
          });
          this.$router.go(-1);
      }).catch((err) => {
          console.log(err)
      })
    }
  }
};
</script>

<style scoped lang="less">
#wrapper {
    width: 100%;
    height: calc(100% - 24px);
    .nameInset {
        width: 100%;
        height: 100%;
        background: rgba(243,245,245,1);
        padding-top: 20px;
        box-sizing: border-box;
        display: block;
        .insetCont {
            width: 100%;
            height: auto;
            position: relative;
            .arrow-right {
                position: absolute;
                top: 50%;
                bottom: 0;
                transform : translate(-50%,-50%);
                right: 13px;
                font-size:20px;
                color: #AAAAAA
            }
            input {
                list-style: none;
                border: none;
                width: 100%;
                height: 45px;
                font-size: 14px;
                font-weight:500;
                color:rgba(49,49,49,1);
                text-indent: 27px;
            }
        }
        .completeCon {
            display: flex;
            width: 100%;
            justify-content: center;
            align-items: center;    
        }
        .complete {
            width:102px;
            height:34px;
            background:rgba(88,68,190,1);
            border-radius:3px;
            line-height: 34px;
            margin-top: 54px;
            color: #fff;
        }
    }
}
</style>
